import { CheckIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

/**
 * The one mark for a finished, rare moment: a project created, terms
 * accepted, a CLI sign-in confirmed. The tick lands first (`ca-pop-in`, 150ms
 * in) and the ring expands once behind the disc after it; both settle on their
 * resting frame, so reduced motion simply shows the finished mark.
 */
export function SuccessMark({ className }: { readonly className?: string }): ReactNode {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'ca-success-ring flex size-10 shrink-0 items-center justify-center rounded-full bg-accent text-accent-foreground',
        className,
      )}
    >
      <CheckIcon className="animate-ca-pop-in" style={{ animationDelay: '150ms' }} />
    </div>
  );
}
